// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightLanding-cls1_TPZ","cls2":"CiterightLanding-cls2_gEn CiterightLanding-cls1_TPZ"};